import { ProcessingParams } from '../../types/stripe/processing-params';

export const handleRequiresPaymentMethod = async ({
  subscription,
  priceId,
  paymentMethodId,
}: ProcessingParams): Promise<ProcessingParams> => {
  if (['active', 'trialing'].includes(subscription.status)) {
    // subscription is active, no customer actions required.
    return { subscription, priceId, paymentMethodId };
  }

  if (
    subscription.latest_invoice.payment_intent.status ===
    'requires_payment_method'
  ) {
    // Store the latest invoice ID and status.
    localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
    localStorage.setItem(
      'latestInvoicePaymentIntentStatus',
      subscription.latest_invoice.payment_intent.status
    );
    throw new Error('Your card was declined.');
  }

  return { subscription, priceId, paymentMethodId };
};
